// extracted by mini-css-extract-plugin
export default {"loader":"LoaderEye_loader__sPSWt"};